export default {
  template_id: 'gh_dropdown',
  html: function (value, func) {
    if (value.class.indexOf('gh_icon') > 0) {
      if(value.icon_id.length == 0) {
        value.icon_id = 'dropdown';
      }
    }
    return `
      <div class="dropdown_element ${ value.class }" ng-mouseenter="positionDropdownMenu($event)">
        ${ value.icon_id || value.name ?
          `<div class="template_icon_title_block_form">
            ${ value.icon_id ? `<span class="template_icon_form" gh-icon="${ value.icon_id } 86BEF6 25px normal"></span>` : `` }
            ${ value.name ? `<span class="template_title_form">${ value.name }</span>` : `` }
            <span class="caret" gh-icon="bot_arrow bbbcc5 15px normal"></span>
            </div>` : ``
        }
        <div class="dropdown_element_childs">${ func(value.content) }</div>
        </div>`;
  }
};
